import type { Maybe } from '@vrplatform/utils';
import type {
  activeStatus_enum,
  listing as Listing,
} from '@vrplatform/graphql';

export const getListingStatus = (
  listing: Maybe<Pick<Listing, 'status' | 'pmsStatus'>>
): activeStatus_enum | 'pmsDisabled' => {
  if (!listing) return 'active';

  if (listing.status) return listing.status;

  if (listing.pmsStatus === 'inactive') return 'pmsDisabled';

  return 'active';
};
